import { FullWarningEvent, WarningEvent, WarningInCalendar } from '../../restapi/types';

export function extractEvents(warnings: WarningInCalendar[],
							  filter: (e: WarningEvent) => boolean): FullWarningEvent[] {
	const res: FullWarningEvent[] = [];
	warnings.forEach(w => {
		const e = w.eventsCalendar[0] || null;
		if (e && (e !== true) && e.id) {
			if (filter(e)) {
				res.push({...e, warning: w});
			}
		}
	});
	return res;
}

export function toggleValue(list: number[], value: number): number[] {
	if (list.includes(value)) {
		return list.filter(v => v !== value);
	} else {
		return [...list, value];
	}
}